import { InputHTMLAttributes, ReactNode } from 'react';

type TInputProps = InputHTMLAttributes<HTMLInputElement> & {
    adornment?: ReactNode
    error?: string | null;
}

function Input({
  adornment, className, error, ...rest
}: TInputProps) {
  return (
    <div className="flex flex-col items-start gap-1">
      <div
        className={`
        input-wrapper ${error ? 'invalid' : ''}
        gradient-border primary before:rounded-[8px] z-[1]
        ${className}
      `}
      >
        <input
          {...rest}
          className={`
            bg-transparent
            w-full
            outline-none
        `}
        />
        {adornment}
      </div>
      <span className="text-[#D42F55] text-xs font-Inria">{error}</span>
    </div>
  );
}

export default Input;
